import { render, staticRenderFns } from "./SCDetails.vue?vue&type=template&id=e18bf250"
import script from "./SCDetails.vue?vue&type=script&lang=js"
export * from "./SCDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports